export default "__VITE_ASSET__BptpWxuj__"